import React, { useEffect } from 'react';

import { useMotionValue, Reorder, MotionValue, animate } from 'framer-motion';

import styles from './Profile.module.scss';

interface Props {
  item: any;
}

export const Item = ({ item }: Props) => {
  const y = useMotionValue(0);
  const boxShadow = useRaisedShadow(y);

  return (
    <Reorder.Item
      value={item[0]}
      id={item}
      style={{ boxShadow, y }}
      className={styles.optionContainer}
    >
      <div className={`${styles.name}`}>{item[0]}</div>
      <div className={`${styles.position} d-flex align-items-center justify-content-center`}>
        {item[1]}
      </div>
    </Reorder.Item>
  );
};

const inactiveShadow = '0px 0px 0px rgba(0,0,0,0.8)';

export function useRaisedShadow(value: MotionValue<number>) {
  const boxShadow = useMotionValue(inactiveShadow);

  useEffect(() => {
    let isActive = false;
    value.onChange((latest) => {
      const wasActive = isActive;
      if (latest !== 0) {
        isActive = true;
        if (isActive !== wasActive) {
          animate(boxShadow, '5px 5px 10px rgba(0,0,0,0.3)');
        }
      } else {
        isActive = false;
        if (isActive !== wasActive) {
          animate(boxShadow, inactiveShadow);
        }
      }
    });
  }, [value, boxShadow]);

  return boxShadow;
}
